import { LOGOUT, RECEIVE_INITIAL_STATE } from "@/components/access/ducks/Actions"
import {
  ADD_EMAIL_DRAFT,
  addEmailDraftSuccess,
  DELETE_EMAIL_DRAFT,
  deleteEmailDraftSuccess,
  FETCH_EMAIL_DRAFTS,
  GET_OUTBOUND_MESSAGES,
  GET_SELECTED_RECIPIENTS,
  receiveEmailDrafts,
  receiveOutboundMessages,
  receiveSelectedRecipients,
  RECEIVE_SELECTED_RECIPIENTS,
  SEND_ADMIN_EMAIL,
  UPDATE_ADMIN_EMAIL_TYPE,
  UPDATE_EMAIL_DRAFT,
  UPDATE_RECIPIENTS,
  updateDraftId,
  updateEmailDraftSuccess,
} from "@/components/email/admin/ducks/Actions"
import {
  apiAddEmailDraft,
  apiDeleteEmailDraft,
  apiGetOutboundMessages,
  apiGetSelectedRecipients,
  apiUpdateEmailDraft,
  fetchEmailDrafts,
  sendAdminEmail,
} from "@/components/email/admin/ducks/AJAX"
import { canScheduleAdminEmail } from "@/components/email/admin/ducks/reducer"
import {
  EMAIL_SENT_RESET,
  TURN_ON_EMAIL_SENT,
  UPDATE_GROUP_EMAIL_TYPE,
} from "@/components/email/ducks/Actions"
import { EmailScheduleActions } from "@/components/email/scheduleStore"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveGetOutboundMessagesSuccess = (cb) => (response) => {
    if (cb) {
      cb()
    }
    dispatch(receiveOutboundMessages(response))
  }
  const receiveSelectedRecipientsSuccess = (response) => {
    dispatch(receiveSelectedRecipients(response.emails, response.hasLargeNumRecp))
  }

  const addEmailDraftWrappedSuccess = (cb) => (draftAddedResponse) => {
    cb()

    dispatch(addEmailDraftSuccess(draftAddedResponse))
    dispatch(updateDraftId(draftAddedResponse?.draftAdded?.draftId || null))
  }

  const updateEmailDraftWrappedSuccess = (cb) => (draftUpdatedResponse) => {
    cb()

    dispatch(updateEmailDraftSuccess(draftUpdatedResponse))
  }

  const deleteEmailDraftWrappedSuccess = (cb, draftId) => () => {
    cb()

    dispatch(deleteEmailDraftSuccess(draftId))
  }

  if (action.type === TURN_ON_EMAIL_SENT && store.getState().email.user.emailIsGroupType) {
    EmailScheduleActions.setSubmitted(null, null)
  }

  if (
    action.type === GET_SELECTED_RECIPIENTS ||
    action.type === EMAIL_SENT_RESET ||
    action.type === UPDATE_GROUP_EMAIL_TYPE ||
    action.type === LOGOUT ||
    action.type === RECEIVE_INITIAL_STATE
  ) {
    EmailScheduleActions.reset()
  }
  if (
    action.type === RECEIVE_SELECTED_RECIPIENTS ||
    action.type === UPDATE_RECIPIENTS ||
    action.type === UPDATE_ADMIN_EMAIL_TYPE
  ) {
    const result = next(action)
    const { adminEmailType, hasLargeNumRecp } = store.getState().email.admin
    if (!canScheduleAdminEmail(adminEmailType, hasLargeNumRecp)) {
      EmailScheduleActions.clearSelection()
    }
    return result
  }

  switch (action.type) {
    case GET_SELECTED_RECIPIENTS: {
      const params = {}

      if (action.recipientIds) {
        params.recipientIds = action.recipientIds
      } else {
        const wf = store.getState().search.user.filters

        if (wf) {
          params.filters = wf
        }
        params.query = store.getState().search.user.query
        params.totalHits = store.getState().search.user.results.total
      }
      apiGetSelectedRecipients(params, receiveSelectedRecipientsSuccess)
      return next(action)
    }

    case SEND_ADMIN_EMAIL:
      sendAdminEmail(action.params, action.success, action.error)
      return next(action)
    case GET_OUTBOUND_MESSAGES:
      apiGetOutboundMessages(
        action.page,
        action.pageSize,
        receiveGetOutboundMessagesSuccess(action.success),
        action.error,
      )
      return next(action)

    case FETCH_EMAIL_DRAFTS:
      fetchEmailDrafts(action.constituentId, receiveEmailDrafts)
      return next(action)

    case ADD_EMAIL_DRAFT:
      apiAddEmailDraft(action.params, addEmailDraftWrappedSuccess(action.success), action.error)
      return next(action)

    case UPDATE_EMAIL_DRAFT:
      apiUpdateEmailDraft(
        action.params,
        updateEmailDraftWrappedSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_EMAIL_DRAFT:
      apiDeleteEmailDraft(
        action.params,
        deleteEmailDraftWrappedSuccess(action.success, action.params.draftId),
        action.error,
      )
      return next(action)

    default:
      return next(action)
  }
}
